import groq from 'groq';

export const blockImageFields = groq`
image->{
  ...,
}
`;
